export const keyframes = {
  active: {
    brightness: 1,
    offset: 0,
    scale: 1,
    translateX: 0,
  },
  after: {
    brightness: 0.6,
    offset: 16,
    scale: 0.9,
    translateX: 5,
  },
  first: {
    brightness: 0.8,
    offset: 10,
    scale: 0.95,
    translateX: 2.5,
  },
  previous: {
    brightness: 1,
    offset: 0,
    scale: 1,
    translateX: -120,
  },
  second: {
    brightness: 0.6,
    offset: 16,
    scale: 0.9,
    translateX: 5,
  },
};

export const getSnapshot = (before, current, after, alpha) => {
  if (alpha >= 0) {
    return current + Math.min(alpha, 1) * (before - current);
  }
  return current + Math.max(alpha, -1) * (current - after);
};

export const getTranslate = (before, current, after, alpha) =>
  `translateX(calc(${getSnapshot(
    before.translateX,
    current.translateX,
    after.translateX,
    alpha,
  )}% + ${getSnapshot(
    before.offset,
    current.offset,
    after.offset,
    alpha,
  )}px )) scale(${getSnapshot(
    before.scale,
    current.scale,
    after.scale,
    alpha,
  )})`;

export const getTable = {
  '-1': (slide, alpha) => {
    const getSlide = slide;
    getSlide.style.filter = `brightness(${keyframes.previous.brightness})`;
    getSlide.style.transform = getTranslate(
      keyframes.previous,
      keyframes.previous,
      keyframes.active,
      alpha,
    );
  },
  0: (slide, alpha) => {
    const getSlide = slide;
    getSlide.style.filter = `brightness(${getSnapshot(
      keyframes.previous.brightness,
      keyframes.active.brightness,
      keyframes.first.brightness,
      alpha,
    )})`;
    getSlide.style.transform = getTranslate(
      keyframes.previous,
      keyframes.active,
      keyframes.first,
      alpha,
    );
  },
  1: (slide, alpha) => {
    const getSlide = slide;
    getSlide.style.filter = `brightness(${getSnapshot(
      keyframes.active.brightness,
      keyframes.first.brightness,
      keyframes.second.brightness,
      alpha,
    )})`;
    getSlide.style.transform = getTranslate(
      keyframes.active,
      keyframes.first,
      keyframes.second,
      alpha,
    );
  },
  2: (slide, alpha) => {
    const getSlide = slide;
    getSlide.style.filter = `brightness(${getSnapshot(
      keyframes.first.brightness,
      keyframes.second.brightness,
      keyframes.second.brightness,
      alpha,
    )})`;
    getSlide.style.transform = getTranslate(
      keyframes.first,
      keyframes.second,
      keyframes.second,
      alpha,
    );
  },
};

export const setSlides = (swiper, slides, alpha, color) => {
  slides.forEach((slide, index) => {
    const getSlide = slide;
    getSlide.style.transition = 'none';
    getSlide.style.zIndex = slides.length - index;
    getSlide.style.background = color;
    getSlide.style.width = '100%';

    const target = index - swiper.activeIndex;
    if (getTable[target] !== undefined) {
      getTable[target](slide, alpha);
    }
  });
};
